import angular from 'angular';

// filter to convert html to plain text
export const loadModule = () =>
  angular.module('app').filter('htmlToPlaintext', function htmlToPlaintext() {
    return function (text) {
      return String(text).replace(/<[^>]+>/gm, '');
    };
  });
